/**
 * @generated SignedSource<<bf3441a4786ebf0d127ff0e6931c1be4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionNoCodeSubmissionPageSubmitAsQuery$variables = {
  competitionId: string;
};
export type CompetitionNoCodeSubmissionPageSubmitAsQuery$data = {
  readonly competition: {
    readonly id: string;
  };
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"UserEntitiesAutocompleteFragment">;
  };
};
export type CompetitionNoCodeSubmissionPageSubmitAsQuery = {
  response: CompetitionNoCodeSubmissionPageSubmitAsQuery$data;
  variables: CompetitionNoCodeSubmissionPageSubmitAsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "competitionId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "competitionId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "fields": [
    {
      "kind": "Variable",
      "name": "on",
      "variableName": "competitionId"
    },
    {
      "kind": "Literal",
      "name": "to",
      "value": "CREATE_SUBMISSION_VERSION"
    }
  ],
  "kind": "ObjectValue",
  "name": "permission"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionNoCodeSubmissionPageSubmitAsQuery",
    "selections": [
      {
        "alias": "competition",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              (v3/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "UserEntitiesAutocompleteFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompetitionNoCodeSubmissionPageSubmitAsQuery",
    "selections": [
      {
        "alias": "competition",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 10
              },
              (v3/*: any*/)
            ],
            "concreteType": "UserEntitiesConnection",
            "kind": "LinkedField",
            "name": "entities",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EntityEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "kind",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "205e1cdd714a1061a9796430786ba2ee",
    "id": null,
    "metadata": {},
    "name": "CompetitionNoCodeSubmissionPageSubmitAsQuery",
    "operationKind": "query",
    "text": "query CompetitionNoCodeSubmissionPageSubmitAsQuery(\n  $competitionId: ID!\n) {\n  competition: node(id: $competitionId) {\n    __typename\n    id\n  }\n  viewer {\n    ...UserEntitiesAutocompleteFragment_4ALydB\n    id\n  }\n}\n\nfragment UserEntitiesAutocompleteFragment_4ALydB on User {\n  id\n  username\n  entities(first: 10, permission: {to: CREATE_SUBMISSION_VERSION, on: $competitionId}) {\n    edges {\n      node {\n        __typename\n        id\n        kind\n        username\n        displayName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c8309104d982382daea73134e6bd9ba9";

export default node;
